var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return ((_vm.inited))?_c('mpx-view',{staticClass:"transition",class:[_vm.$attrs["custom-class"],(_vm.classname)],style:(_vm._f("transRpxStyle")([(_vm.displayStyle)])),on:{"tap":_vm.onClick}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }